export class RoleId {
    static ADMIN = 1        // Администратор
    static ROK = 2          // Руководитель кураторов (Руководитель отдела кураторов)
    static ROK_dep = 3      // Зам. руководителя кураторов
    static RP = 4           // Руководитель предмета
    static SNK11 = 5        // Старший наставник ЕГЭ
    static MCH = 6          // Менеджер чата
    static NK11 = 7         // Наставник стандарт-кураторов ЕГЭ
    static CURATOR11 = 8    // Стандарт-куратор ЕГЭ
    static NLKSK11 = 9      // Наставник ЛК/СК ЕГЭ
    static LK11 = 10        // Личный куратор ЕГЭ
    static SK11 = 11        // Старший куратор ЕГЭ
    static SNK9 = 12        // Старший наставник ОГЭ
    static NK9 = 13         // Наставник стандарт-кураторов ОГЭ
    static CURATOR9 = 14    // Стандарт-куратор ОГЭ
    static NLKSK9 = 15      // Наставник ЛК/СК ОГЭ
    static LK9 = 16         // Личный куратор ОГЭ
    static SK9 = 17         // Старший куратор ОГЭ
    static ROPM = 18        // Руководитель отдела ПМ
    static ROPM_dep = 19    // Зам. руководителя отдела ПМ
    static RG = 20          // Руководитель групп
    static NPM = 21         // Наставник ПМ
    static PM = 22          // ПМ
    static ANALYST = 23     // Аналитик данных
}

export const classesList = [
    {
        id: 1,
        title: "ОГЭ"
    },
    {
        id: 2,
        title: "ЕГЭ"
    },
]

export const months = [
    {
        number: 1,
        name: 'январь'
    },
    {
        number: 2,
        name: 'февраль'
    },
    {
        number: 3,
        name: 'март'
    },
    {
        number: 4,
        name: 'апрель'
    },
    {
        number: 5,
        name: 'май'
    },
    {
        number: 6,
        name: 'июнь'
    },
    {
        number: 7,
        name: 'июль'
    },
    {
        number: 8,
        name: 'август'
    },
    {
        number: 9,
        name: 'сентябрь'
    },
    {
        number: 10,
        name: 'октябрь'
    },
    {
        number: 11,
        name: 'ноябрь'
    },
    {
        number: 12,
        name: 'декабрь'
    }
]
